import {
  Button,
  Colors,
  Cross,
  Modal,
  Typography
} from '@giantleap/components-library'
import * as React from 'react'
import styles from './style.module.scss'

interface IState {}

interface IProps {
  open: boolean
  onSubmit: () => void
  onClose: () => void
}

export class CongratulationsModal extends React.Component<IProps, IState> {
  componentWillUnmount() {
    window.removeEventListener('popstate', this._onBackBrowserBtnEvent)
  }
  componentDidMount() {
    window.addEventListener('popstate', this._onBackBrowserBtnEvent)
  }

  render() {
    const { onSubmit, open } = this.props

    return (
      <Modal
        x={<Cross color={Colors.unselected} size="big" />}
        active={open}
        setActive={this.setActive}
        baseClassName={styles.wrap}
      >
        <Typography type="title" size="big" textAlign="center">
          Congratulations<span style={{ color: Colors.redAccent }}>!</span>
        </Typography>
        <Typography type="text" textAlign="center">
          You successfully created your child’s profile. Now let’s learn how to
          use the parent interface
        </Typography>
        <Button
          onClick={() => {
            window.removeEventListener('popstate', this._onBackBrowserBtnEvent)
            onSubmit()
          }}
          // type="max"
          color="pink"
        >
          Take Tour
        </Button>
      </Modal>
    )
  }
  private _onBackBrowserBtnEvent = event => {
    event.preventDefault()

    const { onClose } = this.props
    onClose()

    window.removeEventListener('popstate', this._onBackBrowserBtnEvent)
  }

  private setActive = (status: boolean) => {
    if (!status) {
      const { onClose } = this.props
      window.removeEventListener('popstate', this._onBackBrowserBtnEvent)
      onClose()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/CongratulationsModal/index.tsx